<div [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme" (mouseover)="sidebarHover()"
     (mouseout)="sidebarHover()">
  <div class="app-header__logo">
    <div class="logo-src">
      <img style="width: 100%;" src=".\assets\images\chettinad-link-logo - Copy - Copy.png" alt="">
    </div>
    <div class="header__pane ms-auto">
      <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
              [ngClass]="{'is-active' : globals.toggleSidebar}" (click)="toggleSidebar()">
        <span class="hamburger-box">
            <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-sidebar-content"  style="background:linear-gradient(90deg, #0071bc, #33a1f2);">
    <div class="app-sidebar-scroll">
      <perfect-scrollbar [autoPropagation]="true">
        <div class="v-sidebar-menu vsm-default">
          <div class="vsm-list">
            <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" [activeIds]="extraParameter">
              <ngb-panel> 
                <ng-template ngbPanelHeader>
                  <div class="text-center mt-3">
                    <img src=".\assets\images\mainuser1.png" alt="a1" style="width: 80px;">
                     <h3 *ngIf="user_permission === '1'" class="text-white fw-bold" style="font-size: 18px;">ADMIN</h3>
                     <h3 *ngIf="user_permission === '2'" class="text-white fw-bold" style="font-size: 18px;">{{user_firstname}}  {{user_lastname}}</h3>
                     <h3 *ngIf="user_permission === '2'" class="text-white fw-bold" style="font-size: 18px;">{{user_number}}</h3>
                  </div>
                </ng-template>  
      
               </ngb-panel> 
              <ngb-panel id="dashboardsMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon fa fa-fw" aria-hidden="true" title="desktop"></i>
                    <span class="vsm-title">Dashboards</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item" *ngIf="user_permission === '1'"><a routerLink="" routerLinkActive="active-item"
                                               [routerLinkActiveOptions]="{exact: true}"  routerLink="analytics" class="vsm-link"><span
                        class="vsm-title">Analytics</span></a>
                      </div>
                      <div class="vsm-item" *ngIf="user_permission === '2'"><a routerLink="users-dashboard" routerLinkActive="active-item"
                                               [routerLinkActiveOptions]="{exact: true}" class="vsm-link"><span
                        class="vsm-title">User Dashboard</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
               
              </ngb-panel>
              
              <ngb-panel id="pagesMenu4" *ngIf="user_permission === '1'">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-graph2"></i>
                    <span class="vsm-title">Accounts</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="user-mgt" class="vsm-link">
                          <span class="vsm-title">User Management</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="post-paid" class="vsm-link">
                          <span class="vsm-title">Usages Plans</span></a>
                      </div>

                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="hot" class="vsm-link">
                          <span class="vsm-title">Hotspots Status</span></a>
                      </div>
                     
                    </div>
                  </div>     
                

                </ng-template>
              </ngb-panel>

              
            </ngb-accordion>
              
          </div> 
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</div>
